import { StyledTableCell } from './styles';
export const TableCell = StyledTableCell;

export default TableCell;
